<template>
    <div>
        <MultiLineChart v-if="Object.keys(plotReadyChartData).length" :height="210" :rawData="plotReadyChartData" />
        <div class="d-flex justify-content-between pr-3 py-2 align-items-center"
            style="border-bottom: 1px solid #D4D4D4;">
            <div style="font-family: Poppins; font-size: 16px; font-weight: 500 !important; color: #000;">Reviews</div>
            <div>
                <button class="sentiment-btn positive" :class="{ 'active': activeBtn === 'positive' }"
                    @click="changeSentimentType('positive')">Positive</button>
                <button class="sentiment-btn negative" :class="{ 'active': activeBtn === 'negative' }"
                    @click="changeSentimentType('negative')">Negative</button>
            </div>
        </div>
        <div class="thin-scroller reviews-container mt-2" v-if="keywordReview.length">
            <div v-for="review of keywordReview" class="section-card my-2 px-2 py-3">
                <a :href="review.review_link" target="_blank" style="text-decoration: none; color: black;">
                    <div class="d-inline-flex justify-content-between align-items-center w-100">
                        <div>
                            <span class="mr-3">
                                <img src="../../../../public/Icons_SVG/profile-svg.svg" width="40">
                            </span>
                            <span style="font-size: 16px; font-weight: 600; letter-spacing: -0.01em;">{{
                                review.person_name }}</span>
                        </div>
                        <span class="d-inline-flex">
                            <IconStar v-for="i in review.rating" :key="i" class="small-star" />
                        </span>
                    </div>
                    <div style="font-size: 14px; padding-block: 6px; margin-block: 16px;">
                        "{{ review.review }}"
                    </div>
                    <div class="d-flex justify-content-between">
                        <div style="font-size: 14px; color: #5e5e5e;">{{ formatReviewDate(review.date) }}</div>
                        <div>
                            <span v-if="review.category" class="px-2 py-1"
                                style="color: #5e5e5e; border: 1px solid #5e5e5e; border-radius: 10px; text-transform: capitalize;">{{
                                    review.category.replaceAll("_", " ") }}</span>
                            <span v-if="review.sub_category">{{ review.sub_category }}</span>
                        </div>
                    </div>
                </a>
            </div>
        </div>
        <div v-else class="noData my-3">
            No data
        </div>
    </div>
</template>
<script>
import IconStar from '../../../assets/IconStar.vue';
import MultiLineChart from '../../commonCharts/MultiLineChart.vue';
import moment from 'moment';

export default {
    name: "KeywordModalCard",
    components: {
        MultiLineChart,
        IconStar
    },
    props: {
        keywordReview: {
            type: Array,
            required: true
        },
        keywordSentiment: {
            type: Object,
            required: true
        },
        chartKey: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            plotReadyChartData: {},
            activeBtn: "positive"
        }
    },
    mounted() {
        this.prepareChartData()
    },
    watch: {
        keywordSentiment: {
            handler() {
                this.prepareChartData();
            },
            deep: true
        },
        chartKey: {
            handler() {
                this.prepareChartData()
            }
        }
    },
    methods: {
        changeSentimentType(sentType) {
            this.activeBtn = sentType;
            this.$emit('filter-reviews', sentType);
        },
        formatReviewDate(date) {
            return moment(date).format("MMM DD, YYYY")
        },
        prepareChartData() {
            let xAxisData = [];
            let yAxisData = [
                {
                    name: "Negative",
                    data: [],
                    color: "#D90000"
                },
                {
                    name: "Positive",
                    data: [],
                    color: "#46A493"
                }
            ];

            this.keywordSentiment.negative.map(dataPoint => {
                xAxisData.push(moment(dataPoint.date).format("DD MMM"));
                yAxisData[0].data.push(dataPoint[this.chartKey]);
            });

            this.keywordSentiment.positive.map(dataPoint => {
                yAxisData[1].data.push(dataPoint[this.chartKey]);
            });

            this.plotReadyChartData = {
                categories: xAxisData,
                seriesData: yAxisData
            }
        }
    }
}
</script>
<style scoped>
.reviews-container {
    max-height: 300px;
    overflow-y: auto;
    border-radius: none !important;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 91.69%, rgba(0, 0, 0, 0.1) 100%) !important;
}

.sentiment-btn {
    font-family: Poppins;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    border-radius: 5px;
    margin-inline: 4px;
    border: none;

    &.all {
        background-color: #065559;
    }

    &.positive {
        color: #46A493;
        border: 2px solid #46A493;
        background-color: transparent;

        &.active {
            color: white;
            background-color: #46A493;
            border-color: transparent;
            &:focus {
                border: 2px solid transparent !important;
                outline: none !important;
                box-shadow: none !important;
            }
        }
    }

    &.negative {
        border: 2px solid #D90000;
        color: #D90000;
        background-color: transparent;

        &.active {
            color: white;
            background-color: #D90000;
            border-color: transparent;
            &:focus {
                border: 2px solid transparent !important;
                outline: none !important;
                box-shadow: none !important;
            }
        }
    }

}

.small-star {
    display: flex;
    width: 16px;
    margin-right: 0px;
    color: #FCB117;
    fill: #FCB117;
}
</style>